



































/* General */
import Vue from 'vue'
import * as routerNames from '@/services/router/router.names'
import MainContainer from '@/layouts/main-container.vue'
import DefaultLayout from '@/layouts/default-layout.vue'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { INavMenuGroup } from '@/types/data-objects/global'

/* API */

export default Vue.extend({
  name: 'EntitySettingsLayout',

  components: {
    MainContainer,
    DefaultLayout,
  },

  props: {
    id: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      routerNames,
      ColorAssistant,
    }
  },

  computed: {
    sidebarElements(): INavMenuGroup[] {
      const items = [
        {
          label: 'Manage',
          options: [
            {
              value: routerNames.PROJECT_SETTINGS_ASSIGN_PEOPLE,
              label: 'Add/Remove Users',
              icon: 'people',
              isActive:
                this.$route.name === routerNames.PROJECT_SETTINGS_ASSIGN_PEOPLE,
            },
            ...(this.$permissions.isTieredPricingPlan
              ? [
                  {
                    value: routerNames.PROJECT_SETTINGS_ASSIGN_GUESTS,
                    label: 'Add/Remove Guests',
                    icon: 'people',
                    isActive:
                      this.$route.name ===
                      routerNames.PROJECT_SETTINGS_ASSIGN_GUESTS,
                  },
                ]
              : []),
            {
              value: routerNames.PROJECT_SETTINGS_CHECKLIST_TEMPLATES,
              label: 'Checklist Templates',
              icon: 'everything',
              isActive:
                this.$route.name ===
                routerNames.PROJECT_SETTINGS_CHECKLIST_TEMPLATES,
            },
            {
              value: routerNames.PROJECT_SETTINGS_DESCRIPTION_TEMPLATES,
              label: 'Description Templates',
              icon: 'description',
              isActive:
                this.$route.name ===
                routerNames.PROJECT_SETTINGS_DESCRIPTION_TEMPLATES,
            },
            {
              value: routerNames.PROJECT_SETTINGS_MANAGE_WORKFLOW,
              label: 'Manage Workflow',
              icon: 'workflows',
              isActive:
                this.$route.name ===
                routerNames.PROJECT_SETTINGS_MANAGE_WORKFLOW,
            },
            {
              value: routerNames.PROJECT_SETTINGS_GENERAL_SETTINGS,
              label: 'General Settings',
              icon: 'cog',
              isActive:
                this.$route.name ===
                routerNames.PROJECT_SETTINGS_GENERAL_SETTINGS,
            },
            {
              value: routerNames.PROJECT_SETTINGS_INTEGRATIONS,
              label: 'Integrations',
              icon: 'integrations',
              isActive:
                this.$route.name === routerNames.PROJECT_SETTINGS_INTEGRATIONS,
            },
          ],
        },
      ]

      return items
    },
  },

  methods: {
    goToProject() {
      RouteAssistant.goToProjectLanding(
        this.$router,
        this.$route.params.accountId,
        this.$route.params.id,
        this.$permissions,
      )
    },
  },
})
